export async function shortenURL(url: string) {
  try {
    const response = await fetch('/api/shorten-url', {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        url
      })
    });

    if (response.ok) {
      const data: any = await response.json();
      return data.url;
    } else {
      throw new Error('Failed to shorten url');
    }
  } catch (err) {
    console.error(err);
  }
}
